import { requestApi } from "../funcitons";

export default {
    getAll: async () => {
        const res = await requestApi('screen_sizes', 'GET');
        return res.data;
    },
}